import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';
import { ProductsService } from 'src/app/lib/services/products.service';

@Component({
    selector: 'app-top-items-catalog',
    templateUrl: './top-items-catalog.component.html',
    styleUrls: ['./top-items-catalog.component.scss'],
    standalone: false
})
export class TopItemsCatalogComponent implements OnInit {
  @Input() active: string;
  @Input() category: any;
  constructor(public modelCtrl: ModalController,
    private productsService: ProductsService,
    private commonService: CommonService,
    public router: Router
  ) { }

  ngOnInit() {
    console.log(this.category);
  }

  async cancel() {
    await this.modelCtrl.dismiss('back');
  }

  async addTopItems(itemCount: any) {
    var topItemsData: any = {
      "category_id": this.category.id,
      "top_items": itemCount
    }

    const loading = await this.commonService.presentLoader();
    loading.present();
    this.productsService.addTopItemsCatalog(topItemsData).subscribe({
      next: (res: any) => {
        console.log(res);
        loading.dismiss();
        if (res.success) {
          this.commonService.success(res.data);
          this.router.navigate(['/my-catalog']);
          this.modelCtrl.dismiss(res);
        } else if (res && res.error) {
          this.commonService.danger(res.error.message);
        }
      },
      error: (error: HttpErrorResponse) => {
        loading.dismiss();
        this.commonService.danger('Something Went Wrong !!');
      }
    });
  }

}
